import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { CustomAtrributeValue } from '@shared/interfaces/attribute-description.interface';
import { TemplateName } from '@src/app/shared/constants/visibility-config.const';

@Component({
  selector: 'app-venture-phase-detail',
  templateUrl: './venture-phase-detail.component.html',
})
export class VenturePhaseDetailComponent implements OnChanges, AfterViewInit {
  @Input() currentIndex = 2;
  @Input() allPhases: Array<CustomAtrributeValue>;
  @Input() editable = false;
  @Input() showFullPhaseText = false;
  @Input() uiTemplateName: TemplateName;

  @Output() selectItem = new EventEmitter();

  @ViewChildren('phaseCircle', { read: ElementRef })
  circleEls!: QueryList<ElementRef>;
  @ViewChildren('phaseBar', { read: ElementRef })
  barEls!: QueryList<ElementRef>;

  templateName = TemplateName;

  constructor(private readonly renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentIndex || changes.allPhases) {
      if (this.allPhases) {
        this.allPhases.forEach((phase) => {
          if (
            phase.codeId === this.currentIndex ||
            phase.value === this.currentIndex ||
            phase.order === this.currentIndex
          ) {
            this.currentIndex = phase.order;
          }
        });
      }
    }
  }

  ngAfterViewInit(): void {
    this.handleLongPhaseText();
  }

  select(item: CustomAtrributeValue, index): void {
    if (this.editable) {
      this.currentIndex = index;
      this.selectItem.next(item);
    }
  }

  handleLongPhaseText(): void {
    const firstCircleEl = this.circleEls.first?.nativeElement;

    if (!firstCircleEl) return;

    const barArray = this.barEls.map((ref) => ref.nativeElement);
    let firstBarWidth: number;

    for (const barEl of barArray) {
      const position = firstCircleEl.compareDocumentPosition(barEl);
      const isNext = position && Node.DOCUMENT_POSITION_FOLLOWING;
      if (isNext) {
        const width = barEl.getBoundingClientRect().width;
        firstBarWidth = width;

        break;
      }
    }

    if (firstBarWidth) {
      const phaseText = firstCircleEl.querySelector('.phase-text');
      if (phaseText) {
        this.renderer.setStyle(
          phaseText,
          'max-width',
          `${((firstBarWidth + 20 * 2) / 2) - 10}px`
        );
      }
    }
  }
}
